import ClinicOnboardCapacityModal from "@/app/components/routes/modals/ClinicOnboardCapacity";
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from "@/constants";
import Input from "@/app/components/ui/Inputs/Input";
import NonSearchableSelectMenu from "@/app/components/ui/SelectMenus/NonSearchableSelectMenu";
import StepperSelectMenu from "@/app/components/ui/SelectMenus/StepperSelectMenu";
import Toggle from "@/app/components/ui/Toggles";
import { ISelectMenuItemData } from "@/app/components/ui/interface";
import { useConfigurationClinicDetailAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationClinicDetailAPI";
import { useConfigurationClinicOnboardAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationClinicOnboardAPI";
import { useConfigurationClinicUpdateAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationClinicUpdateAPI";
import { useConfigurationEquipmentServiceListAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationEquipmentServicesListAPI";
import { useConfigurationPincodeAndStateByCityAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationPincodeAndStateByCityApi";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import useFormValidations, { ALIAS_CODE_SANITIZE_REGEX } from "@/app/hooks/useFormValidations";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { IConfigurationListState, setClinicCopyImagesList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import { IClinicOnboardProps } from "./interface";
import { useOrderManagementClinicListAPI } from "@/app/hooks/api_hooks/orders/useOrderClinicListAPI";
import { useConfigurationCityListAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationCityListAPI";
import {
  buildClinicImagesPayload,
  buildClinicPayload,
  useClinicFormHydration,
  useClinicImagesHydration,
  useImageValidator,
  useNormalizedServiceTypes,
  validateClinicForm,
} from "@/app/hooks/custom_hooks";
import ClinicOnboardImagesStep from "./ClinicOnboardImagesStep";
import CreatableSelect from "react-select/creatable";
import toast from "react-hot-toast";

const RemoveIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
    <path
      d="M14.25 5.3075L13.1925 4.25L9 8.4425L4.8075 4.25L3.75 5.3075L7.9425 9.5L3.75 13.6925L4.8075 14.75L9 10.5575L13.1925 14.75L14.25 13.6925L10.0575 9.5L14.25 5.3075Z"
      fill="black"
    />
  </svg>
);

const ConfigurationClinicOnboard = () => {
  let clinicDetailsFetched = false;
  let serviceFetched = false;
  let citiesFetched = false;
  const params = useParams();
  const { setVisible: clinicOnboardCapacity } = useModalActions("CLINIC_ONBOARD_CAPACITY");
  const { setVisible: imageCategoryModal, setModalData: setImgCategory } = useModalActions("IMAGE_CATEGORY_MODAL");
  const { setVisible: copyImageModal } = useModalActions("COPY_IMAGE_MODAL");
  const formHook = useForm<IClinicOnboardProps>({
    mode: "onChange",
  });
  // useFormValidations returns RegisterOptions<any, string>, whose `deps` type doesn't
  // line up with formHook.register's field-literal generic; relax the types at the call site only.
  const register = formHook.register as (name: any, options?: any) => ReturnType<typeof formHook.register>;
  const navigate = useNavigate();
  const {
    forMobile,
    forEmail,
    forLatitude,
    forLongitude,
    forRatingScore,
    forAlphaNumeric,
    forOnlyNumber,
    forName,
    forAlphaNumericWithGST,
    forUrl,
    forGmbPlaceId,
    forLocationPath,
    forClinicAddressLine,
    forAliasCode,
  } = useFormValidations();
  const { getRouteKey } = useRouter();
  const fetchEquipmentService = useConfigurationEquipmentServiceListAPI();
  const routeIdPWL = getRouteKey("CONFIGURATION", "id");
  const { routeState: servicesList } = useRouteInfo(routeIdPWL);
  const { equipmentService } = servicesList.state as IConfigurationListState;
  const fetchCities = useConfigurationCityListAPI();
  const { routeState: routeStateCities } = useRouteInfo(routeIdPWL);
  const { cityList } = routeStateCities.state as IConfigurationListState;
  const { addressByCity: cityData, execute: fetchAddressDetails } = useConfigurationPincodeAndStateByCityAPI();
  const cityOrgItem = useSelectMenuReducer(cityList, "name", "id");
  const [currentStep, setCurrentStep] = useState(1);
  const arrayConstants = useArrayConstants();
  const startTimeItem = arrayConstants.overBookingStartTimeItems as ISelectMenuItemData[];
  const startTimeMinuteItem = arrayConstants.overBookingStartTimeMinuteItems as ISelectMenuItemData[];
  const { clinicDetails, execute: fetchClinicDetail } = useConfigurationClinicDetailAPI();
  const routeIdConfig = getRouteKey("CONFIGURATION", "id");
  const { routeState } = useRouteInfo(routeIdConfig);
  const { clinicCopyImagesList: clinicImagesList } = routeState.state as IConfigurationListState;
  const [listcategories, setListcategories] = useState({});
  const [detailcategories, setDetailcategories] = useState({});
  const defaultCategories = ["FACADE", "RECEPTION", "GROOMING", "MEDICAL", "RETAIL"];
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const [isForEdit, setIsForEdit] = useState<boolean>(false);
  const { newClinicId, execute: onboardNewClinic } = useConfigurationClinicOnboardAPI();
  const { updatedClinicId, execute: updateClinicCategory } = useConfigurationClinicUpdateAPI();
  const counterState = useModalState("CLINIC_ONBOARD_CAPACITY");
  const [isSubmit, setIsSubmit] = useState(false);
  const [capacityfetched, setCapacityfetched] = useState(false);
  const dispatch = useAppDispatch();
  const [defaultSelectedIds, setDefaultSelectedIds] = useState<string[]>([]);
  const { options, serviceIdToServiceTypeIdMap } = useNormalizedServiceTypes(equipmentService);
  const { validateImage } = useImageValidator();

  useEffect(() => {
    if (!serviceFetched) {
      serviceFetched = true;
      fetchEquipmentService();
    }
  }, []);

  const getEmptyServices = (data: IClinicOnboardProps) => {
    const emptyServices = data?.services
      ?.filter((s) => s?.sub_services_data?.length == 0 || s == undefined)
      ?.map((s) => s?.service_id);
    return emptyServices;
  };

  const validateFormData = (data: IClinicOnboardProps) => {
    const services = data?.services;
    let isValid = true;
    if (services?.length === 0) {
      formHook?.setError("services", {
        type: "required",
        message: "Please select a service and it's sub-service",
      });
      isValid = false;
    }
    const emptyServices = getEmptyServices(data);
    if (emptyServices?.length > 0) {
      formHook?.setError("services", {
        type: "custom",
        message: `sub-services should be selected.`,
      });
      isValid = false;
    }
    if (isValid) {
      formHook.clearErrors("services");
    }
    return isValid;
  };

  const Submit = (data: IClinicOnboardProps) => {
    setIsSubmit(true);
    if (
      Object.values(formHook.watch("clinic_listing_page")).some((s) => s?.length == 0) ||
      Object.values(formHook.watch("clinic_details_page")).some((s) => s?.length == 0) ||
      Object.values(listcategories).some((s: string[]) => s?.length == 0) ||
      Object.values(detailcategories).some((s: string[]) => s?.length == 0)
    ) {
      return;
    }
    const imagesPayload = buildClinicImagesPayload(formHook, listcategories, detailcategories);
    // if (
    //   Object.keys(imagesPayload.clinic_listing_page)?.length < 5 ||
    //   Object.keys(imagesPayload.clinic_details_page)?.length < 5
    // ) {
    //   return;
    // }
    if (
      Object.keys(imagesPayload.clinic_listing_page)?.length < 4 ||
      Object.keys(imagesPayload.clinic_details_page)?.length < 4
    ) {
      return;
    }
    const payload = buildClinicPayload(data, formHook, counterState);
    if (!isForEdit) {
      onboardNewClinic({
        ...payload,
        ...imagesPayload,
      });
    } else {
      updateClinicCategory(
        {
          ...payload,
          ...imagesPayload,
        },
        params["clinic_id"],
      );
    }
  };

  useEffect(() => {
    if (newClinicId || updatedClinicId) {
      setImgCategory("");
      dispatch(setClinicCopyImagesList({ data: [] }));
      navigate(getRouteKey("CLINIC_SETUP", "url"));
    }
  }, [newClinicId, updatedClinicId]);

  useClinicImagesHydration(clinicImagesList, formHook, setListcategories, setDetailcategories);

  useEffect(() => {
    if (formHook.getValues("services")?.length > 0) {
      validateClinicForm(formHook.getValues(), formHook);
    }
  }, [formHook.getValues("services")]);

  useEffect(() => {
    if (params["clinic_id"] && !clinicDetailsFetched && !clinicDetails) {
      clinicDetailsFetched = true;
      const clinicId = params["clinic_id"];
      fetchClinicDetail(clinicId);
      setIsForEdit(true);
    }
  }, [params["clinic_id"]]);

  useClinicFormHydration(
    clinicDetails,
    formHook,
    setListcategories,
    setDetailcategories,
    setDefaultSelectedIds,
    serviceIdToServiceTypeIdMap.serviceIdToServiceTypeIdMap,
    days,
  );

  useEffect(() => {
    if (!citiesFetched) {
      citiesFetched = true;
      fetchCities();
    }
  }, []);

  useEffect(() => {
    if (cityData) {
      formHook.setValue("state", cityData?.state);
      formHook.setValue("pincode", cityData?.pincode);
    }
  }, [cityData]);

  useEffect(() => {
    const selectedCity = formHook.watch("city_select")?.name;
    if (selectedCity) {
      fetchAddressDetails(selectedCity);
    }
  }, [formHook.watch("city_select"), fetchAddressDetails]);

  const handleCancel = () => {
    formHook.reset();
    clinicDetailsFetched = false;
    navigate(getRouteKey("CLINIC_SETUP", "url"));
  };

  const handleNext = () => {
    if (currentStep < 2) {
      formHook.trigger().then((res) => {
        const isServicesValid = validateClinicForm(formHook.getValues(), formHook);
        if (res && isServicesValid) {
          setCurrentStep(currentStep + 1);
        }
      });
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleImageUpload = async (event: React.ChangeEvent<HTMLInputElement>, key, category) => {
    const files = event.target.files;
    const images: string[] = [];
    if (!files) return;
    for (const file of Array.from(files)) {
      if (file) {
        const result = await validateImage(file, key);
        if (result.isValid) {
          images.push(result.imgSrc);
        } else {
          if (!result.isPng) {
            toast.error("Please upload a .png file.");
          } else if (!result.isSizeValid) {
            toast.error("Please upload an image less than 50KB.");
          } else if (!result.isDimensionsValid) {
            toast.error(
              `Please upload an image with dimensions ${key == "clinic_details_page" || key == "details_category" ? "360x200" : "328x160"} pixels.`,
            );
          }
        }
      }
    }
    if (key == "image") {
      formHook.setValue("image", images[0]);
    } else if (key == "listing_category") {
      setListcategories((prev) => ({ ...prev, [category]: [...prev[category], ...images] }));
    } else if (key == "details_category") {
      setDetailcategories((prev) => ({ ...prev, [category]: [...prev[category], ...images] }));
    } else {
      let prev = formHook.watch(key);
      if (prev && category in prev) {
        prev = prev[category];
      } else {
        prev = [];
      }
      formHook.setValue(key, { ...formHook.watch(key), [category]: [...prev, ...images] });
    }
  };

  const handleRemoveImage = (key, category, i) => {
    if (key == "image") {
      formHook.setValue("image", "");
    } else if (key == "listing_category") {
      setListcategories((prev) => {
        const newListCategories = { ...prev };
        if (newListCategories[category].length == 1) {
          delete newListCategories[category];
        } else {
          newListCategories[category] = newListCategories[category]?.filter((_, j) => j != i);
        }
        return newListCategories;
      });
    } else if (key == "details_category") {
      setDetailcategories((prev) => {
        const newDetailCategories = { ...prev };
        if (newDetailCategories[category]?.length == 1) {
          delete newDetailCategories[category];
        } else {
          newDetailCategories[category] = newDetailCategories[category]?.filter((_, j) => j != i);
        }
        return newDetailCategories;
      });
    } else {
      const prev = formHook.watch(key);
      if (prev[category]?.length == 1) {
        const { [category]: deletedcategory, ...rest } = prev;
        formHook.setValue(key, rest);
      } else {
        formHook.setValue(key, {
          ...prev,
          [category]: prev[category]?.filter((_, j) => j != i),
        });
      }
    }
  };

  const handleRemoveAll = (key, category) => {
    if (key == "listing_category") {
      setListcategories((prev) => {
        const newListCategories = { ...prev };
        newListCategories[category] = [];
        return newListCategories;
      });
    } else if (key == "details_category") {
      setDetailcategories((prev) => {
        const newListCategories = { ...prev };
        newListCategories[category] = [];
        return newListCategories;
      });
    } else {
      const { [category]: deletedcategory, ...rest } = formHook.watch(key);
      formHook.setValue(key, rest);
    }
  };

  const handleDeleteCategory = (key, category: string) => {
    setImgCategory("");
    if (key === "listing_category") {
      setListcategories((prev: { [key: string]: string }) => {
        const { [category]: deletedCategory, ...newList } = prev;
        return newList;
      });
    }
    if (key === "details_category") {
      setDetailcategories((prev) => {
        const newDetailCategories = { ...prev };
        delete newDetailCategories[category];
        return newDetailCategories;
      });
    }
  };

  const handleTimeChange = (day, field, key, value) => {
    const time = {
      start_time: {
        hours: field == "hh" && key == "start" ? value : formHook.watch(day)?.["start_time"]?.["hours"] || undefined,
        minutes:
          field == "mm" && key == "start" ? value : formHook.watch(day)?.["start_time"]?.["minutes"] || undefined,
      },
      end_time: {
        hours: field == "hh" && key == "end" ? value : formHook.watch(day)?.["end_time"]?.["hours"] || undefined,
        minutes: field == "mm" && key == "end" ? value : formHook.watch(day)?.["end_time"]?.["minutes"] || undefined,
      },
    };
    formHook.setValue(day, time);
    checkTimeErrors(day);
  };

  const copyAllValues = () => {
    const mondayTime = formHook.getValues("monday");
    days?.forEach((day: any) => {
      formHook.setValue(day.toLowerCase(), mondayTime);
      formHook.clearErrors(day);
    });
  };

  const checkTimeErrors = (day) => {
    if (
      formHook.watch(day)?.["start_time"]?.["hours"] &&
      formHook.watch(day)?.["start_time"]?.["minutes"] &&
      formHook.watch(day)?.["end_time"]?.["hours"] &&
      formHook.watch(day)?.["end_time"]?.["minutes"]
    ) {
      formHook.clearErrors(day);
    }
  };

  const handleInputChange = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    inputValue = inputValue.slice(0, 15);
    formHook.setValue("gstn", inputValue);
  };

  const clearError = (field: any) => () => formHook.clearErrors(field);

  const numericOnlyChange = (field: any) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = e.target.value.replace(/[^0-9.]/g, "");
    if (/^\d*\.?\d*$/.test(numericValue)) {
      formHook.setValue(field, numericValue);
      formHook.clearErrors(field);
    }
  };

  const integerOnlyChange = (field: any) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const integerValue = e.target.value.replace(/[^0-9]/g, "");
    formHook.setValue(field, integerValue);
    formHook.clearErrors(field);
  };

  let imagesFetched = false;

  const clinicListAPI = useOrderManagementClinicListAPI();
  const routeIdOrder = getRouteKey("ORDER_MANAGEMENT", "id");
  const { routeState: routeStateConfig } = useRouteInfo(routeIdOrder);

  useEffect(() => {
    if (!imagesFetched) {
      clinicListAPI();
      imagesFetched = true;
    }
  }, []);

  const clinicsOrg = routeStateConfig?.state?.clinicList?.results;
  const clinicsOrgItem = useSelectMenuReducer(clinicsOrg, "name", "id");

  const renderTimeSelect = (day, timeKey, valueKey, items, placeholder, onSelectItem) => (
    <div className="w-[100px]">
      <NonSearchableSelectMenu
        errorMessages={[]}
        onSelectItem={onSelectItem}
        fieldError={formHook.formState.errors?.[day]}
        register={formHook.register(day, { required: true })}
        selectItems={items}
        placeholder={placeholder}
        showTooltips={false}
        showDropdownIcon={true}
        defaultSelected={items?.filter((oc) => oc?.title === formHook.watch(day)?.[timeKey]?.[valueKey])[0]}
        listBoxClassName="w-full"
        className="text-gray-800"
        containerClassName="w-24"
      />
      {formHook.formState.errors?.[day] && formHook.watch(day)?.[timeKey]?.[valueKey] == undefined && (
        <div className="text-[9px]  mt-1 text-red-500">{placeholder} is required</div>
      )}
    </div>
  );
  const searchTagStyles = {
    placeholder: (provided) => ({
      ...provided,
      "@apply text-sm": "text-xs",
    }),
    singleValue: (provided) => ({
      ...provided,
      "@apply text-sm": "",
    }),
    multiValue: (provided) => ({
      ...provided,
      "@apply text-sm": "text-xs",
    }),
    input: (provided) => ({
      ...provided,
      "@apply text-sm": "",
    }),
  };

  const renderDaySchedule = (day) => (
    <div key={day}>
      <div className="flex gap-8">
        <div className="mt-6 w-[80px]">
          <p className="text-black text-xs font-medium">{day}</p>
        </div>
        <div className="flex gap-1 mt-3">
          {renderTimeSelect(day, "start_time", "hours", startTimeItem, "HH", (item) => {
            if (item) {
              handleTimeChange(day, "hh", "start", item?.title);
            }
          })}
          {renderTimeSelect(day, "start_time", "minutes", startTimeMinuteItem, "MM", (item) =>
            handleTimeChange(day, "mm", "start", item?.title),
          )}
        </div>
        <div className="mt-3 flex gap-1">
          {renderTimeSelect(day, "end_time", "hours", startTimeItem, "HH", (item) =>
            handleTimeChange(day, "hh", "end", item?.title),
          )}
          {renderTimeSelect(day, "end_time", "minutes", startTimeMinuteItem, "MM", (item) =>
            handleTimeChange(day, "mm", "end", item?.title),
          )}
        </div>
      </div>
    </div>
  );

  const renderStep1 = () => (
    <>
      <div className="text-black text-base font-semibold bg-white rounded-md py-2">Clinic Setup</div>
      <div>
        <div className="justify-start items-baseline flex mt-3">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Clinic Name</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            register={register("clinicName", {
              required: true,
            })}
            errorMessages={[{ type: "required", message: "Clinic Name is required" }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.clinicName}
            placeholder="Enter Clinic Name"
            onChange={clearError("clinicName")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Alias Code</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            maxLength={5}
            register={formHook.register("clinicCode", {
              required: true,
              ...forAliasCode.validations,
            })}
            errorMessages={[{ type: "required", message: "Alias Code is required" }, forAliasCode.errors]}
            readOnly={isForEdit}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            inputClassName={isForEdit ? "bg-gray-100 cursor-not-allowed" : ""}
            fieldError={formHook.formState.errors.clinicCode}
            placeholder="Enter Alias Code (e.g. ABC)"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              if (isForEdit) return;
              const value = e.target.value.replace(ALIAS_CODE_SANITIZE_REGEX, "").toUpperCase().slice(0, 5);
              formHook.setValue("clinicCode", value, { shouldValidate: true });
            }}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Contact Number</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            maxLength={10}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            placeholder="Enter Contact Number"
            register={register("mobile", {
              ...forMobile.validations,
              maxLength: 10,
              required: true,
            })}
            fieldError={formHook.formState.errors.mobile}
            errorMessages={[
              forMobile.errors,
              { type: "required", message: "Contact number is required" },
              { type: "maxLength", message: "Invalid contact number" },
            ]}
            onChange={clearError("mobile")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Email Id</span>
          </div>
          <Input
            register={register("email", {
              ...forEmail.validations,
              maxLength: 30,
            })}
            errorMessages={[forEmail.errors, { type: "maxLength", message: "Email too long." }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.email}
            placeholder="Enter Email Id"
            onChange={clearError("email")}
          />
        </div>
        <div className="justify-start flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Address</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <div className="block">
            <Input
              register={register("address1", {
                required: true,
                ...forClinicAddressLine.validations,
              })}
              errorMessages={[forClinicAddressLine.errors, { type: "required", message: "Address is required" }]}
              className="h-9 w-[300px] text-xs rounded-md border-slate-400"
              fieldError={formHook.formState.errors.address1}
              placeholder="Enter Address Line 1"
              onChange={clearError("address1")}
            />
            <Input
              register={register("address2", {
                required: false,
              })}
              errorMessages={[]}
              className="h-9 w-[300px] text-xs rounded-md border-slate-400 mt-4"
              fieldError={formHook.formState.errors.address2}
              placeholder="Address Line 2"
              onChange={clearError("address2")}
            />
            <Input
              register={register("nearby_landmarks", {
                required: true,
                ...forClinicAddressLine.validations,
              })}
              errorMessages={[
                forClinicAddressLine.errors,
                { type: "required", message: "Nearby landmarks is required" },
              ]}
              className="h-9 w-[300px] text-xs rounded-md border-slate-400 mt-4"
              fieldError={formHook.formState.errors.nearby_landmarks}
              placeholder="Nearby Landmarks *"
              onChange={clearError("nearby_landmarks")}
            />
            <div className="flex gap-3 mt-3">
              <div className="h-9 w-[150px] mt-2">
                <NonSearchableSelectMenu
                  errorMessages={[{ type: "required", message: "City is required" }]}
                  onSelectItem={(item) => {
                    if (item) {
                      formHook.setValue("city_select", { id: item?.id, name: item?.title });
                      formHook.clearErrors("city_select");
                    }
                  }}
                  fieldError={formHook.formState.errors.city_select}
                  register={formHook.register("city_select", { required: true })}
                  selectItems={cityOrgItem}
                  placeholder="Select City"
                  className="h-9 w-[300px] text-xs py-2 rounded-md border border-slate-400"
                  showTooltips={false}
                  showTypedErrors={true}
                  showDropdownIcon={true}
                  defaultSelected={cityOrgItem?.filter((oc) => oc.title === formHook.watch("city_select")?.name)[0]}
                />
              </div>
              <div>
                <Input
                  register={formHook.register("state", {
                    required: true,
                  })}
                  errorMessages={[]}
                  className="h-9 w-[150px] text-xs rounded-md border-slate-400 mt-2"
                  fieldError={formHook.formState.errors.state}
                  placeholder="State"
                />
              </div>
            </div>
            <Input
              register={formHook?.register("pincode", {
                validate: (value) => {
                  const isNumeric = /^[0-9]*$/.test(value);
                  return isNumeric || "Only numbers are allowed";
                },
                required: true,
                maxLength: 6,
                minLength: 6,
              })}
              readOnly={false}
              errorMessages={[
                forOnlyNumber?.errors,
                { type: "required", message: "Pincode is required" },
                { type: "minLength", message: "Pincode should be of 6 digits" },
                { type: "validate", message: "Only numbers are allowed" },
              ]}
              className="h-9 w-[150px] text-xs mt-5 rounded-md border-slate-400"
              fieldError={formHook.formState.errors.pincode}
              placeholder="Pincode"
            />
          </div>
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Latitude</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            register={register("latitude", {
              ...forLatitude.validations,
              required: true,
            })}
            errorMessages={[forLatitude.errors, { type: "required", message: "Latitude is required" }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors?.latitude}
            placeholder="Enter Latitude"
            onChange={numericOnlyChange("latitude")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Longitude</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            register={register("longitude", {
              ...forLongitude.validations,
              required: true,
            })}
            errorMessages={[forLongitude.errors, { type: "required", message: "Longitude is required" }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.longitude}
            placeholder="Enter Longitude"
            onChange={numericOnlyChange("longitude")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">GSTN</span>
          </div>
          <Input
            register={register("gstn", {
              ...forAlphaNumericWithGST.validations,
              maxLength: 15,
              minLength: 15,
              required: false,
            })}
            errorMessages={[
              forAlphaNumericWithGST.errors,
              { type: "maxLength", message: "Invalid gstn" },
              { type: "minLength", message: "GSTN should not less than 15" },
            ]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.gstn}
            placeholder="Enter GSTN"
            onChange={(event) => {
              handleInputChange(event);
              formHook.clearErrors("gstn");
            }}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Choose Services</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <div id="servicesDropdown" className="w-[300px]">
            <StepperSelectMenu
              options={options}
              showDropdownIcon
              onChange={(data) => {
                formHook.setValue("services", data);
                validateClinicForm(formHook.getValues(), formHook);
              }}
              defaultSelectedIds={defaultSelectedIds}
            />
            {formHook.formState.errors?.services && (
              <div className="text-[9px] mt-1 text-red-500">{formHook.formState.errors.services.message as string}</div>
            )}
          </div>
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Operational Capacity</span>
          </div>
          <div
            className="text-blue-600 cursor-pointer text-xs font-medium underline"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setCapacityfetched(true);
              clinicOnboardCapacity();
            }}
          >
            Setup
          </div>
          {capacityfetched && <ClinicOnboardCapacityModal />}
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Rating</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            maxLength={4}
            register={register("rating", {
              ...forRatingScore.validations,
              required: true,
            })}
            errorMessages={[forRatingScore.errors, { type: "required", message: "Rating is required." }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.rating}
            placeholder="Enter Rating (0-5)"
            onChange={numericOnlyChange("rating")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Total Reviews</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            maxLength={10}
            register={register("reviews", {
              ...forOnlyNumber.validations,
              required: true,
            })}
            errorMessages={[forOnlyNumber.errors, { type: "required", message: "Total Review is required." }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.reviews}
            placeholder="Enter Total Reviews"
            onChange={integerOnlyChange("reviews")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">VetBuddy Instance ID</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            register={register("instanceId", {
              ...forAlphaNumeric.validations,
              required: true,
            })}
            errorMessages={[forAlphaNumeric.errors, { type: "required", message: "VetBuddy Instance ID is required." }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.instanceId}
            placeholder="Enter VetBuddy Instance ID"
            onChange={clearError("instanceId")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">VetBuddy Clinic ID</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            register={register("clinicId", {
              ...forAlphaNumeric.validations,
              required: true,
            })}
            errorMessages={[forAlphaNumeric.errors, { type: "required", message: "VetBuddy Clinic ID is required." }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.clinicId}
            placeholder="Enter VetBuddy Clinic ID"
            onChange={clearError("clinicId")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">VetBuddy Clinic Name</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            register={register("vetbuddyClinicName", {
              ...forName.validations,
              required: true,
              ...forName.validations,
            })}
            errorMessages={[forName.errors, { type: "required", message: "VetBuddy Clinic Name is required." }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.vetbuddyClinicName}
            placeholder="Enter VetBuddy Clinic Name"
            onChange={clearError("vetbuddyClinicName")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Display Name</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            register={register("displayName", {
              required: true,
            })}
            errorMessages={[{ type: "required", message: "Display Name is required." }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.displayName}
            placeholder="Enter Clinic Name to be Displayed"
            onChange={clearError("displayName")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Review URL</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            register={register("reviewUrl", {
              ...forUrl.validations,
              required: true,
            })}
            errorMessages={[forUrl.errors, { type: "required", message: "Review URL is required." }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.reviewUrl}
            placeholder="Enter Review URL"
            onChange={clearError("reviewUrl")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">GMB Place ID</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            register={register("gmbPlaceId", {
              ...forGmbPlaceId.validations,
              required: true,
            })}
            errorMessages={[forGmbPlaceId.errors, { type: "required", message: "GMB Place ID is required." }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.gmbPlaceId}
            placeholder="Enter GMB Place ID"
            onChange={clearError("gmbPlaceId")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Location URL</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            register={register("locationUrl", {
              ...forUrl.validations,
              required: true,
            })}
            errorMessages={[forUrl.errors, { type: "required", message: "Location URL is required." }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.locationUrl}
            placeholder="Enter Location URL"
            onChange={clearError("locationUrl")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-7">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Web URL Path</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <Input
            register={register("webUrlPath", {
              ...forUrl.validations,
              required: true,
            })}
            errorMessages={[forUrl.errors, { type: "required", message: "Web URL Path is required." }]}
            className="h-9 w-[300px] text-xs rounded-md border-slate-400"
            fieldError={formHook.formState.errors.webUrlPath}
            placeholder="Enter Web URL Path"
            onChange={clearError("webUrlPath")}
          />
        </div>
        <div className="justify-start items-baseline flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Search Tags</span>
          </div>
          <div className="w-[300px]">
            <div className=" rounded-lg h-auto">
              <CreatableSelect
                isMulti
                value={(formHook.watch("search_tags") || []).map((t: string) => ({ label: t, value: t }))}
                onChange={(newValue) => {
                  const cleaned = newValue
                    .map((opt: any) => opt?.value?.trim())
                    .filter((val: string) => val && val.length > 0);
                  formHook.setValue("search_tags", cleaned);
                }}
                className="text-xs border-none"
                options={[]}
                placeholder="Type and press enter to add tags"
                styles={searchTagStyles}
              />
            </div>
          </div>
        </div>
        <div className="justify-start items-center flex mt-10">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Visiting Hours</span>
            <span className="text-rose-600 text-xs font-normal">*</span>
          </div>
          <div>
            <div className="flex justify-around">
              <p className="text-black text-xs ml-[7rem] font-medium">Start Time</p>
              <p className="text-black text-xs ml-[11rem] font-medium">End Time</p>
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  copyAllValues();
                }}
                className={`${PRIMARY_BUTTON} ml-[10rem]`}
              >
                Copy All
              </button>
            </div>
            {days.map((day) => renderDaySchedule(day.toLowerCase()))}
          </div>
        </div>
        <div className="justify-start items-center flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Display on App</span>
          </div>
          <Toggle
            checked={formHook.watch("displayOnApp")}
            onToggle={(state) => {
              formHook.setValue("displayOnApp", state);
            }}
          />
        </div>
        <div className="justify-start items-center flex mt-5">
          <div className="h-[38px] p-2.5 justify-start w-[200px] items-center gap-1 flex">
            <span className="text-black text-xs font-normal">Display on VMS</span>
          </div>
          <Toggle
            checked={formHook.watch("displayOnVms")}
            onToggle={(state) => {
              formHook.setValue("displayOnVms", state);
            }}
          />
        </div>
      </div>
    </>
  );

  return (
    <>
      <div className="mx-3 bg-white rounded-md py-3">
        <form
          onSubmit={formHook?.handleSubmit(
            (data) => {
              if (validateFormData(formHook?.getValues())) Submit(data);
            },
            (_errors) => {
              validateFormData(formHook?.getValues());
            },
          )}
        >
          {currentStep === 1 && renderStep1()}
          {currentStep === 2 && (
            <ClinicOnboardImagesStep
              formHook={formHook}
              listcategories={listcategories}
              detailcategories={detailcategories}
              isSubmit={isSubmit}
              defaultCategories={defaultCategories}
              clinicsOrgItem={clinicsOrgItem}
              handleImageUpload={handleImageUpload}
              handleRemoveImage={handleRemoveImage}
              handleRemoveAll={handleRemoveAll}
              handleDeleteCategory={handleDeleteCategory}
              copyImageModal={copyImageModal}
              imageCategoryModal={imageCategoryModal}
            />
          )}

          <div className="justify-end items-center gap-4 inline-flex sticky bottom-0 right-0 p-3 w-full bg-white border-t-2">
            {currentStep > 1 && (
              <button type="button" onClick={handlePrevious} className={SECONDARY_BUTTON}>
                Back
              </button>
            )}
            {currentStep === 1 && (
              <button type="button" onClick={handleCancel} className={SECONDARY_BUTTON}>
                Cancel
              </button>
            )}
            {/* `!` needed: the size token's `sm:text-xs` sits in a media query and would win otherwise. */}
            {currentStep < 2 ? (
              <button type="button" onClick={handleNext} className={PRIMARY_BUTTON}>
                Next
              </button>
            ) : (
              <button type="submit" className={PRIMARY_BUTTON}>
                Save
              </button>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default ConfigurationClinicOnboard;
